import React from "react"
import ArtPieceSharedDetails from "./SharedDetails"

const ArtPieceAudio = () => {
  return (
    <>
      <ArtPieceSharedDetails />
    </>
  )
}

export default ArtPieceAudio
